module.exports = __webpack_public_path__ + "da8cf20c1552db3c2605596d2be81077.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/night.jpg
 ** module id = 195
 ** module chunks = 0
 **/